<template lang="pug">
  div(v-if="isInitialized").wrap-item-slide-user.slide-user
    VueDragResize(:x="pos.x" :y="pos.y" w="auto" h="auto"
      :isResizable="false"
      @dragstop="dragstop")
        div.slide-user.cursor-pointer
          AtomUserReaction(:user="user"
            :messages="messages" :userMessages="userMessages"
            @setIconAnimation="setIconAnimation"
            @playEmortSound="playEmortSound" @playMsgPopSound="playMsgPopSound")
          div(:class="iconAnimation")
            div(:class="{'active': uid === user.id}").wrap-icon.f.fh
              v-img(:src="user.iconPhotoURL")
          v-icon(v-if="isHost" size="14px"
            :color="pallete.$safe_color").host-mark mdi-checkbox-blank-circle
          span.name-label.block.text-center.fz12.line-clamp-1 {{user.name}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/animation.scss";

.wrap-item-slide-user {
  .slide-user {
    position: relative;
    .wrap-icon {
      filter: $drop_shadow;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      &.active {
        border: solid $active_color 2px;
      }
    }
    .host-mark {
      position: absolute;
      right: -1px;
      bottom: -1px;
    }
    .name-label {
      position: absolute;
      top: calc(100% + 2px);
      width: 60px;
      height: 18px;
      left: 50%;
      margin-left: -30px;
      overflow: hidden;
      color: $secondary_text_color;
      word-break: keep-all;
    }
  }
}
</style>

<style lang="scss">
.wrap-item-slide-user {
  .vdr.active:before {
    display: none !important;
  }
  .vdr {
    border: none !important;
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import VueDragResize from 'vue-drag-resize'
import AtomUserReaction from '@/components/atom/AtomUserReaction'

export default {
  components: {
    VueDragResize,
    AtomUserReaction
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    slide: {
      type: Object,
      required: true
    },
    parentSlideElem: {
      type: HTMLDivElement,
      required: true
    },
    messages: {
      type: Array,
      required: true
    }
  },
  watch: {
    user () {
      if (this.user.id !== this.uid) this.updateUserPos()
    }
  },
  data () {
    return {
      pos: { x: 0, y: 0 },
      isInitialized: false,
      initTimer: null,
      resizeTimer: null,
      preventDragStop: false,
      iconAnimation: ''
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    isHost () {
      return this.user.uid === this.slide.createdBy
    },
    userMessages () {
      return this.messages.filter(msg => msg.createdBy === this.user.id)
    }
  },
  created () {
    // setInterval(this.autoMoveForDemo, 5000)
  },
  mounted () {
    this.initTimer = setInterval(this.initUser, 1000)
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    async autoMoveForDemo () {
      await this.sleep(Math.floor(Math.random() * 1000))
      let pos = { 
        x: Math.floor(Math.random() * 100),
        y: Math.floor(Math.random() * 100)
      } // %
      database.userCollection().update(this.uid, { pos })
    },
    initUser () {
      // 画像が読み込まれるまで待機
      if (this.parentSlideElem.clientWidth > 0
      && this.parentSlideElem.clientHeight > 0) {
        this.updateUserPos()
        clearInterval(this.initTimer)
        this.isInitialized = true
      }
    },
    dragstop (e) {
      if (!this.isInitialized || this.uid !== this.user.id) return
      if (this.preventDragStop) return
      // console.log('dragstop')
      const posXpercent = e.left / this.parentSlideElem.clientWidth * 100
      const posYpercent = e.top / this.parentSlideElem.clientHeight * 100
      if (posXpercent && posYpercent) {
        let pos = { x: posXpercent, y: posYpercent } // %
        database.userCollection().update(this.uid, { pos })
        // console.log(pos)
      }
    },
    updateUserPos () {
      // convert % to px
      let posXpx = this.parentSlideElem.clientWidth * this.user.pos.x / 100
      let posYpx = this.parentSlideElem.clientHeight * this.user.pos.y / 100
      this.pos = { x: posXpx, y: posYpx }
      
      // console.log(this.user.name + ' updateUserPos:', this.pos)
    },
    onResize () {
      // console.log('onResize')
      clearTimeout(this.resizeTimer)
      this.preventDragStop = true

      this.resizeTimer = setTimeout(async () => {
        // console.log('resize end', this)
        this.updateUserPos()

        await this.sleep(800)
        this.preventDragStop = false
      }, 1000)
    },
    setIconAnimation (iconAnimation) {
      this.iconAnimation = iconAnimation
    },
    playMsgPopSound (params) {
      this.$emit('playMsgPopSound', params)
    },
    playEmortSound (params) {
      this.$emit('playEmortSound', params)
    }
  }
}
</script>
